<template>
  <v-dialog v-model="visible" max-width="1000">
    <v-card class="person-list-dialog">
      <v-card-title class="dialog-header">
        <div class="header-left">
          <span class="title-bar"></span>
          <span class="dialog-title-text">查看人员清单</span>
        </div>
        <div class="header-right">
          <span class="status-badge" :class="getStatusClass(info.coverStatus)">{{ info.coverStatusStr }}</span>
          <v-btn icon small class="close-btn" @click="close">
            <v-icon small>close</v-icon>
          </v-btn>
        </div>
      </v-card-title>
      <v-card-text class="dialog-body">
        <!-- 保单基本信息 -->
        <div class="policy-info-section">
          <div class="info-row">
            <span class="info-item"><span class="label">保单号：</span>{{ info.insurerPolicyCode }}</span>
            <span class="info-item"><span class="label">投保人：</span>{{ info.name }}</span>
            <span class="info-item"><span class="label">投保期限：</span>{{ info.effectiveDate }} 至 {{ info.expiryDate }}</span>
          </div>
          <div class="info-row">
            <span class="info-item"><span class="label">保障方案：</span><span class="highlight">{{ info.productName }}</span></span>
          </div>
        </div>

        <!-- 搜索和操作 -->
        <div class="search-section">
          <v-text-field
            v-model="searchName"
            placeholder="姓名"
            outlined
            dense
            solo
            hide-details
            class="search-input"
          ></v-text-field>
          <v-text-field
            v-model="searchIdNo"
            placeholder="身份证号"
            outlined
            dense
            solo
            hide-details
            class="search-input"
          ></v-text-field>
          <v-btn color="#dd122a" small class="search-btn" @click="search">搜索</v-btn>
          <v-btn outlined color="#999" small class="reset-btn" @click="resetSearch">清空</v-btn>
          <v-btn outlined color="#dd122a" small class="export-btn" @click="exportList">
            导出人员清单
          </v-btn>
        </div>

        <!-- 人员列表表格 -->
        <div class="person-table-wrapper">
          <div v-if="loading" class="loading-mask">
            <v-progress-circular indeterminate color="#dd122a"></v-progress-circular>
          </div>
          <table class="person-table" v-else>
            <thead>
              <tr>
                <th>姓名</th>
                <th>证件类型</th>
                <th>证件号码</th>
                <th>出生日期</th>
                <th>性别</th>
                <th>同投保人关系</th>
                <th>联系方式</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(person, index) in list" :key="index">
                <td>{{ person.name }}</td>
                <td>{{ person.certTypeStr }}</td>
                <td>{{ person.certNo }}</td>
                <td>{{ person.birthday }}</td>
                <td>{{ person.genderStr }}</td>
                <td>{{ person.relationTypeStr }}</td>
                <td>{{ person.phone }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 分页 -->
        <div class="dialog-pagination">
          <v-pagination
            v-model="currentPage"
            :length="totalPages"
            :total-visible="7"
            color="#dd122a"
          ></v-pagination>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { getInsuredList, exportInsuredList } from '@/api/travelInsurance';

export default {
  name: 'PersonListDialog',
  data() {
    return {
      visible: false,
      searchName: '',
      searchIdNo: '',
      list: [],
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      totalCount: 0,
      loading: false,
      info: {},
    };
  },
  watch: {
    currentPage(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getList();
      }
    }
  },
  methods: {
    close() {
      this.visible = false;
      this.currentPage = 1;
      this.info = {};
    },
    loadList(info) {
      this.info = info;
      this.visible = true;
      this.getList();
      
    },
    getList(){
      const params = {
        policyId: this.info.id,
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        name: this.searchName,
        certNo: this.searchIdNo
      };
      this.loading = true;
      getInsuredList(params).then(res => {
        if (res.code === 0 || res.success) {
          const pageData = res.data || {};
          this.list = pageData.records || [];
          this.totalCount = pageData.total || 0;
          this.totalPages = pageData.pages || 1;
        }
      }).catch(err => {
        console.error('获取人员列表失败:', err);
      }).finally(() => {
        this.loading = false;
      });
    },
    search() {
      this.currentPage = 1;
      this.getList();
    },
    exportList() {
      const params = {
        policyId: this.info.id,
        name: this.searchName || undefined,
        certNo: this.searchIdNo || undefined
      };
      exportInsuredList(params).then(res => {
        const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `人员清单_${this.info.insurerPolicyCode}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(link.href);
      }).catch(err => {
        console.error('导出失败:', err);
        this.$message.error('导出失败');
      });
    },
    resetSearch() {
      this.searchName = '';
      this.searchIdNo = '';
      this.currentPage = 1;
      this.getList();
    },
    getStatusClass(status) {
      const statusMap = {
        0: 'status-pending',
        5: 'status-active',
        9: 'status-expired',
        8: 'status-canceled'
      };
      return statusMap[status] || '';
    }
  }
};
</script>

<style lang="scss" scoped>
.person-list-dialog {
  .dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px 24px;
    border-bottom: 1px solid #e8e8e8;

    .header-left {
      display: flex;
      align-items: center;
      gap: 8px;

      .title-bar {
        width: 4px;
        height: 16px;
        background-color: #dd122a;
        border-radius: 2px;
      }

      .dialog-title-text {
        font-size: 16px;
        font-weight: 500;
        color: #333;
      }
    }

    .header-right {
      display: flex;
      align-items: center;
      gap: 12px;

      .status-badge {
        padding: 2px 6px;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 600;

        &.status-pending {
          background-color: #DBEAFE;
          color: #007DFF;
        }

        &.status-active {
          background-color: #DCFCE8;
          color: #18813E;
        }

        &.status-expired {
          background-color: #FDF1F2;
          color: #DD122A;
        }

        &.status-canceled {
          background-color: #EEEEEE;
          color: #93969B;
        }
      }

      .close-btn {
        width: 28px;
        height: 28px;

        .v-icon {
          color: #999;
          font-size: 18px;
        }

        &:hover .v-icon {
          color: #666;
        }
      }
    }
  }

  .dialog-body {
    padding: 20px 24px;

    .policy-info-section {
      margin-bottom: 20px;

      .info-row {
        display: flex;
        flex-wrap: wrap;
        gap: 40px;
        margin-bottom: 12px;

        .info-item {
          font-size: 14px;
          color: #262626;

          .label {
            color: #93969B;
          }

          .highlight {
            color: #dd122a;
          }
        }
      }
    }

    .search-section {
      display: flex;
      align-items: flex-start;
      gap: 12px;
      margin-bottom: 16px;

      .search-input {
        width: 200px;
        margin-top: 0;
        padding-top: 0;

        ::v-deep .v-input__slot {
          min-height: 36px;
          height: 36px;
          border-radius: 4px;
        }

        ::v-deep .v-text-field--outlined fieldset {
          border-color: #dcdcdc;
        }

        ::v-deep input {
          padding-top: 0;
          padding-bottom: 0;
        }
      }

      .search-btn,
      .reset-btn,
      .export-btn {
        text-transform: none;
        font-weight: normal;
        height: 36px;
        margin-top: 0;
        color: #fff;
      }

      .search-btn {
        color: #fff;
      }
    }

    .person-table-wrapper {
      border: 1px solid #e8e8e8;
      border-radius: 8px;
      overflow: hidden;
      margin-bottom: 16px;
      overflow-x: auto;
    }

    .person-table {
      width: 100%;
      border-collapse: collapse;
      font-size: 14px;

      thead {
        background-color: #F5F5F5;

        th {
          padding: 12px 8px;
          text-align: center;
          font-weight: 500;
          color: #333;
          border-bottom: 1px solid #e8e8e8;
          white-space: nowrap;
        }
      }

      tbody {
        tr {
          border-bottom: 1px solid #e8e8e8;

          &:last-child {
            border-bottom: none;
          }

          &:hover {
            background-color: #fafafa;
          }

          td {
            padding: 12px 8px;
            text-align: center;
            vertical-align: middle;
            color: #333;
          }
        }
      }
    }

    .dialog-pagination {
      display: flex;
      justify-content: flex-end;

      ::v-deep .v-pagination__item {
        font-size: 13px;
      }

      ::v-deep .v-pagination__navigation {
        i {
          font-size: 18px;
        }
      }
    }

    .loading-mask {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(255, 255, 255, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10;
    }
  }
}
</style>
